
import api from '../../api/api';
import { history } from '../../../history';
import * as routerPath from '../../constants/routePaths';
import * as all from '../../../global';

//retrieve the role description
function RetrieveRelatedRoles(PartyRelatedRoleID) {
  const url = `api/ReferenceDataService/RetrieveRelatedRoles?id=${PartyRelatedRoleID}`
  return api.request(url, 'get').then(response => {
    return response.ReferenceDataCollection;
  })
}

//retrieve the RelocationPurposes
function RetrieveRelocationPurposes(relocationPlanPurpose) {
  const servicesRequest = relocationPlanPurpose;
  const url = `api/OrderDetailService/RetrieveRelocationPlanPurposesDetails`;
  const content = {
    RelocationPlanPurposeDetails: {
      CaseID: servicesRequest.CaseID,
      ProductGroupCode: servicesRequest.ProductGroupCode,
      TravelTypeID: servicesRequest.TravelTypeID
    }
  }
  return api.request(url, "post", content).then(res => {
    return res;
  })
}

// this Component public Api search dropDown
function referenceDataService(GenericID, urlSuffix) {
  const url = `api/ReferenceDataService/${urlSuffix}?id=${GenericID}`;
  return api.request(url, "get").then(response => {
    if (response.Successful) {
      return response.ReferenceDataCollection || response.VehicleTypes;
    }
    else {
      history.push(routerPath.ERRORGOHOME);
    }
  });
}

//
function RetrieveTitlesByTitleSetCode(code) {

  const url = `api/ReferenceDataService/RetrieveTitlesByTitleSetCode`;
  const content = { "Code": code }
  return api.request(url, "post", content).then(response => {
    return response.ReferenceDataCollection;
  })
}

// new logic for relocationStep
function getRelocationStepsNew(currentStep) {
  switch (currentStep) {
    case 'Introduction':
      return 1;
    case 'PersonalDetails':
      return 2;
    case 'RelocationDetails':
      return 3;
    case 'Dependants':
      return 3;
    case 'HousingConsiderations':
      return 4;
    case 'PetDetails':
      return 5;
    case 'Travel':
      return 6;
    case 'Logistics':
      return 6;
    case 'Accommodation':
      return 7;
    case 'OtherConsiderations':
      return 8;
    case 'Removals':
      return 9;
    case 'Itinerary':
      return 9;
    case 'Authorisation':
      return 10;
    case 'Declaration':
      return 11;
    case 'SubmitAFR':
      return 12;
    default:
      return 1;
  }

}


// getRelocationSteps

function getRelocationSteps(currStep) {
  let relocationStepIndex = {};
  var prevStepValid = false;
  var nextStepValid = false;
  relocationStepIndex.currRelocationStep = currStep;
  relocationStepIndex.currActionPage = getActionPage(currStep);

  let nextStep = all.RelocationBookmark.SubmitAFR;
  let prevStep = all.RelocationBookmark.RelocationDetails;
  const menu = '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1';
  let mnuServicesSteps = menu.split(",");
  // Next Relocation Steps
  //housing consideration
  if (mnuServicesSteps[0] === "1" && !nextStepValid && currStep < 5) {
    nextStep = all.RelocationBookmark.HousingConsideration;
    nextStepValid = true;
  }
  //pet details
  else if (mnuServicesSteps[1] === "1" && !nextStepValid && currStep < 6) {
    nextStep = all.RelocationBookmark.PetDetails;
    nextStepValid = true;
  }
  //travel
  else if (mnuServicesSteps[2] === "1" && !nextStepValid && currStep < 9) {
    nextStep = all.RelocationBookmark.Travel;
    nextStepValid = true;
  }
  //accommodation
  else if (mnuServicesSteps[4] === "1" && !nextStepValid && currStep < 10) {
    nextStep = all.RelocationBookmark.Accommodation;
    nextStepValid = true;
  }
  // Other consideration
  else if (mnuServicesSteps[5] === "1" && !nextStepValid && currStep < 11) {
    nextStep = all.RelocationBookmark.OtherConsiderations;
    nextStepValid = true;
  }
  // Itinerary
  else if (mnuServicesSteps[6] === "1" && !nextStepValid && currStep < 13) {
    nextStep = all.RelocationBookmark.Itinerary;
    nextStepValid = true;
  }
  // Authorization
  else if (mnuServicesSteps[7] === "1" && !nextStepValid && currStep < 14) {
    nextStep = all.RelocationBookmark.Authorisation;
    nextStepValid = true;
  }
  // Declaration
  else if (mnuServicesSteps[8] === "1" && !nextStepValid && currStep < 15) {
    nextStep = all.RelocationBookmark.Declaration;
    nextStepValid = true;
  }
  else {
    nextStep = all.RelocationBookmark.SubmitAFR;
    nextStepValid = true;
  }
  relocationStepIndex.nextRelocationStep = nextStep;
  relocationStepIndex.nextActionPage = getActionPage(nextStep);

  // Previous relocation Step
  //Declaration
  if (mnuServicesSteps[8] === "1" && !prevStepValid && currStep > 15) {
    prevStep = all.RelocationBookmark.Declaration;
    prevStepValid = true;
  }
  //Authorization
  else if (mnuServicesSteps[7] === "1" && !prevStepValid && currStep > 14) {
    prevStep = all.RelocationBookmark.Authorisation;
    prevStepValid = true;
  }
  //Itinerary
  else if (mnuServicesSteps[6] === "1" && !prevStepValid && currStep > 13) {
    prevStep = all.RelocationBookmark.Itinerary;
    prevStepValid = true;
  }
  //Other consideration
  if (mnuServicesSteps[5] === "1" && !prevStepValid && currStep > 11) {
    prevStep = all.RelocationBookmark.OtherConsiderations;
    prevStepValid = true;
  }
  //accommodation
  else if (mnuServicesSteps[4] === "1" && !prevStepValid && currStep > 10) {
    prevStep = all.RelocationBookmark.Accommodation;
    prevStepValid = true;
  }
  // travel
  else if (mnuServicesSteps[2] === "1" && !prevStepValid && currStep > 9) {
    prevStep = all.RelocationBookmark.Travel;
    prevStepValid = true;
  }
  // Pet Details
  else if (mnuServicesSteps[1] === "1" && !prevStepValid && currStep > 6) {
    prevStep = all.RelocationBookmark.PetDetails;
    prevStepValid = true;
  }
  // housing consideration
  else if (mnuServicesSteps[0] === "1" && !prevStepValid && currStep > 5) {
    prevStep = all.RelocationBookmark.HousingConsideration;
    prevStepValid = true;
  }
  else {
    prevStep = all.RelocationBookmark.RelocationDetails;
    prevStepValid = true;
  }
  relocationStepIndex.prevRelocationStep = prevStep;
  relocationStepIndex.prevActionPage = getActionPage(prevStep);

  return relocationStepIndex;
}

//currActionPage
function getActionPage(relocationStep) {
  let actionPage = "Introduction"; //Default Action PAge
  let isIntlDefence = false;
  let relocationStep2 = "RelocationDetails";
  if (sessionStorage.getItem("IsDefenceInternational") !== null && sessionStorage.getItem("IsDefenceInternational") !== "")
    isIntlDefence = sessionStorage.getItem("IsDefenceInternational");

  if (isIntlDefence)
    relocationStep2 = "DependantDetails_Govt";
  else
    relocationStep2 = "RelocationDetails";
  switch (relocationStep) {

    case 1: actionPage = "Introduction"; break;
    case 2: actionPage = "PersonalDetails"; break;
    case 4: actionPage = relocationStep2; break;
    case 5: actionPage = "HousingConsideration"; break;
    case 6: actionPage = "PetDetails"; break;
    case 9: actionPage = "TravelDetails"; break;
    //  case 9: stepIdx = "Logistics"; break;
    case 10: actionPage = "TemporaryAccommodation"; break;
    case 11: actionPage = "OtherConsideration"; break;
    case 13: actionPage = "Itinerary"; break;
    //  case 13: stepIdx = "Itenerary"; break;
    case 14: actionPage = "DebitAuthorisation"; break;
    case 15: actionPage = "Declaration"; break;
    default: break;

  }
  return actionPage;
}

//pamare list 
function listDelRepetition(list) {
  const map = new Map();
  const array = [];
  list.forEach(element => {
    if (map.has(element)) {
      map.set(element)
    } else {
      map.set(element);
      array.push(element);
    }
  });
  return array;
}

// delete id === "6"
function getTravelTypesListIdOnly(list) {
  let genericTypesList = list;
  list.forEach((genericType, index) => {
    if (genericType.Id.toString() === "6") {
      genericTypesList.splice(index, 1);
    }
  })
  return genericTypesList;
}

// TravelServices getTravelTypesList
function getTravelTypesList(travelTypes, bundlesAndServices, selectedBundlesAndServices) {
  let validTravelTypes = [];
  bundlesAndServices.Bundles.forEach(bundle => {
    if (bundle.BundleName !== "Standalone Services") {
      if (selectedBundlesAndServices.Bundles.find(m => m.BundleName === bundle.BundleName)) {
        bundle.Services.forEach(service => {
          if (service.ServiceCode === "FLIGHT" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("FLIGHT");
          }
          else if (service.ServiceCode === "OWNMEANS" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("OWNMEANS");
          }
          else if (service.ServiceCode === "RAIL" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("RAIL");
          }
          else if (service.ServiceCode === "COACH" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("COACH");
          }
          else if (service.ServiceCode === "FERRY" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("FERRY");
          }
          else if (service.ServiceCode === "ACCOM" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("ACCOM");
          }
        })
      }
    }

    if (bundle.BundleName === "Standalone Services") {
      if (selectedBundlesAndServices.StandaloneServices.find(m => (m.ServiceCode === "FLIGHT" || m.ServiceCode === "OWNMEANS" || m.ServiceCode === "RAIL" ||
        m.ServiceCode === "COACH" || m.ServiceCode === "FERRY" || m.ServiceCode === "ACCOM"))) {
        bundle.Services.forEach(service => {
          if (service.ServiceCode === "FLIGHT" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("FLIGHT");
          }
          else if (service.ServiceCode === "OWNMEANS" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("OWNMEANS");
          }
          else if (service.ServiceCode === "RAIL" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("RAIL");
          }
          else if (service.ServiceCode === "COACH" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("COACH");
          }
          else if (service.ServiceCode === "FERRY" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("FERRY");
          }
          else if (service.ServiceCode === "ACCOM" && service.ServiceCategoryCode === "TRAVEL") {
            validTravelTypes.push("ACCOM");
          }
        })
      }
    }
  })
  let genericTypesList = [];
  genericTypesList.push({ Value: "", Text: "GenericDdlOptionPleaseSelect" });
  travelTypes.forEach(genericType => {
    if (genericType.Id.toString() !== "6" && validTravelTypes.find(m => m === genericType.Code.toString())) {
      genericTypesList.push({
        Value: genericType.Id.toString() + "|" + genericType.Code.toString() + "|" + genericType.Description.toString(),
        Text: genericType.Description
      })
    }
  })

  return listDelRepetition(genericTypesList);
}

// TravelServices getClientBundlesAndServices
function RetrieveClientBundlesAndServices(clientServices) {
  const servicesRequest = JSON.parse(clientServices);
  const url = `api/ClientDetailService/RetrieveClientBundlesAndStandAloneServices`;
  const content = {
    ClientServicesRequestDetails: {
      ClientCode: servicesRequest.ClientCode,
      ClientType: servicesRequest.ClientType,
      CountryOfOrigin: servicesRequest.CountryOfOrigin !== null ? servicesRequest.CountryOfOrigin.toLowerCase() : null,
      CountryOfDestination: servicesRequest.CountryOfDestination !== null ? servicesRequest.CountryOfDestination.toLowerCase() : null,
      CityOfDestination: servicesRequest.CityOfDestination !== null ? servicesRequest.CityOfDestination.toLowerCase() : null,
      CaseCreationDate: new Date()
    }
  }
  return api.request(url, "post", content).then(res => {
    return res;
  })
}

//TravelServices getRetrieveSelectedBundlesAndServices
function RetrieveSelectedBundlesAndServices(casesId) {
  const url = `api/Case/${casesId}/BundlesAndStandaloneServices`;
  return api.request(url, "get", null)
    .then(res => res)
    .catch(err => {
    })
}

// get data pamare url Id; 
function RetrieveRelocationPlanSteps(id, url) {

  const content = {
    Id: id
  }
  return api.request(url, "post", content).then(res => {
    return res;
  })
}

// String not null && not ""
function NotNullOrEmpty(data) {
  if (data !== null && data !== "") {
    return true;
  } else {
    return false;
  }
}
//
function NotNullOrWhiteSpace(data) {
  if (data !== null && data !== " ") {
    return true;
  } else {
    return false;
  }
}



export default {
  RetrieveRelatedRoles,
  RetrieveRelocationPurposes,
  referenceDataService,
  getRelocationSteps,
  getRelocationStepsNew,
  listDelRepetition,
  getTravelTypesListIdOnly,
  getTravelTypesList,
  RetrieveClientBundlesAndServices,
  RetrieveSelectedBundlesAndServices,
  RetrieveRelocationPlanSteps,
  NotNullOrEmpty,
  NotNullOrWhiteSpace,
  RetrieveTitlesByTitleSetCode
};